import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import {
  broadcastCreateReportError,
  broadcastReportCreated,
} from 'serviceWorker/broadcasts/reports';

export function broadcastReportResponse(
  request: HttpRequestEntity,
  response: any,
  uniqueId?: string
): void {
  const resolvedUniqueId = uniqueId ?? request.data?.uniqueId;

  if (response.error) {
    return broadcastCreateReportError(response.error, resolvedUniqueId);
  }

  broadcastReportCreated(response, resolvedUniqueId);
}
